import React from "react";
import { Link } from "react-router-dom";
import Heading from "../../components/atoms/Heading";

export const ResetPasswordConfirmationPage = () => {
  return (
    <>
      <div className="container mt-2 text-center">
        <Heading h2 className="mb-2">
          Password reset confirmation
        </Heading>

        <div className="confirmation-message">          
          <div className="mb-2">
            Password successfully updated
            <br />
            Please log in again using your new password to
            <br />
            continue your Artetra journey
          </div>

          <div className="mt-4">
            <Link 
              to="/auth/login" 
              style={{ textDecoration: 'none' }}
            >
              Log in
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
